module.exports = __webpack_public_path__ + "static/media/doit.2005d77d.png";